import React from 'react'
import { Grid } from '@components/layout/Grid'
import { DataAccessTable } from './components/DataAccessTable'
import { SecurityCard } from './components/SecurityCard'
import { UserDetailsCard } from './components/UserDetailsCard'
import { Button } from "@UILibrary/Button"

import styles from './user-profile.module.sass'

export const UserProfile = ({ user, dataAccess, permissions, securitySettingsPath }) => {
  return (
    <div className={styles.userProfileLayout}>
      <header className={styles.profileHeader}>
        <div>
          <h1>{user.name}</h1>
          {user.lastSignedInAt ? <p>Last sign-in {user.lastSignedInAt} ago</p> : <p>Never signed in</p>}
        </div>
        <Button variant="primary" onClick={() => document.location.href = `/clients/${user.id}/scenarios/dashboard`}>
          View Dashboard
        </Button>
      </header>

      <Grid className={styles.summaryLayout}>
        <section>
          <header>
            <h2>Profile</h2>
            <p>Basic details</p>
          </header>
          <UserDetailsCard user={user} canEdit={permissions.includes('client:edit')} />
        </section>

        <section>
          <header>
            <h2>Data Access</h2>
            <p>Who has access to my data</p>
          </header>
          <DataAccessTable dataAccess={dataAccess} />
        </section>

        <section>
          <header>
            <h2>Security</h2>
            <p>How we check it is you when you sign in</p>
          </header>
          <SecurityCard securitySettingsPath={securitySettingsPath} />
        </section>
      </Grid>
    </div>
  )
}
